import { Injectable } from '@angular/core';

import { BaseEditService } from 'tms-lib';

@Injectable({
  providedIn: 'root',
})
export abstract class TmsWebBaseEditService<T, TEdit> extends BaseEditService<T, TEdit> {
  protected constructor(baseRoute: string, name: string) {
    super(baseRoute, name);
  }

  protected get apiUrl() {
    return `TmsWeb/${this.baseRoute}`;
  }
}
